import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';

const WithAuth = (WrappedComponent, protectedRoutes) => {
    const {data} = useAuth();
    const location = useLocation();
    
    // Check if user is logged in
    const isLoggedIn = Object.keys(data).length > 0;
    
    // If not logged in, redirect to login
    if (!isLoggedIn) {
        return <Navigate to="/login" />;
    }
    
    // User is logged in, show the component
    // KYC is only for new signups/onboarding, not for existing users
    return <WrappedComponent />;
}

export default WithAuth;